import React from 'react';
import Layout from '../components/Layout';
import './Skills.css';

const Skills: React.FC = () => {
  const skills = [
    { category: 'フロントエンド', items: ['React', 'TypeScript', 'JavaScript'] },
    { category: 'バックエンド', items: ['Python', 'Java', 'Ruby'] },
    { category: 'その他', items: ['Git', 'Github', 'Linux'] },
  ];

  return (
    <Layout>
      <div className="skills-container">
        <h2>使用技術一覧</h2>
        {skills.map((group, idx) => (
          <div key={idx} className="skill-group">
            <h3>{group.category}</h3>
            <ul>
              {group.items.map((skill) => (
                <li key={skill}>✔ {skill}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </Layout>
  );
};

export default Skills;


  
